import React from "react";
import { Box, Autocomplete, TextField } from "@mui/material";
import { ReactComponent as GradientInputBorder } from "../../assets/gradient-input-border.svg";

export interface GradientBorderAutocompleteProps {
  options: string[];
  inputValue: string;
  onInputChange: (event: any, newInputValue: string) => void;
  label: string;
  sx?: any;
  height?: number;
  width?: number;
}

export const GradientBorderAutocomplete: React.FC<GradientBorderAutocompleteProps> = ({
  options,
  inputValue,
  onInputChange,
  label,
  sx,
  height = 40,
  width,
}) => {
  return (
    <Box sx={{ position: "relative", width: width, height: height, ...sx }}>
      {/* SVGボーダーを背景として配置 */}
      <GradientInputBorder
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Autocompleteを上に配置 */}
      <Autocomplete
        freeSolo
        options={options}
        inputValue={inputValue}
        onInputChange={onInputChange}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={label}
            size="small"
            sx={{
              width: "100%",
              height: "100%",
              "& .MuiOutlinedInput-root": {
                height: "100%",
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
                backgroundColor: "transparent",
                borderRadius: "4px",
              },
              "& .MuiInputBase-input": {
                padding: "8px 12px",
                "&::placeholder": {
                  color: "#999",
                  opacity: 1,
                },
              },
            }}
          />
        )}
      />
    </Box>
  );
};
